import React from 'react'
import StudentLayer from '../components/student/AddStudentLayer'
import MasterLayout from '../masterLayout/MasterLayout'

function AddStudentPage() {
    return (
        <MasterLayout>
        <StudentLayer />    
        </MasterLayout>
    )
}

export default AddStudentPage